import { utilGrid } from "../utils/grid/utilGrid";
import { selectExpansionInfo } from "./selectExpansionInfo";
var Point = PIXI.Point;
export var selectUnlockableExpansionIds = function (state) {
    var unlockedExpansionIds = state.baseInfo.expansionIds || [];
    var baseSetup = selectExpansionInfo(state).baseSetup;
    var set = unlockedExpansionIds.reduce(function (acc, id) {
        utilGrid
            .getExpansionNeighbours(id, baseSetup)
            .filter(function (neighbourId) { return unlockedExpansionIds.indexOf(neighbourId) === -1; })
            .forEach(function (neighbourId) { return acc.add(neighbourId); });
        return acc;
    }, new Set());
    return Array.from(set);
};
export var selectAutoSelectedExpansionId = function (state) {
    return selectUnlockableExpansionIds(state)
        .sort()
        .pop();
};
export var selectExpansionXYFromIdGlobal = function (state, expansionId, viewport) {
    var baseSetup = selectExpansionInfo(state).baseSetup;
    var _a = utilGrid.expansionIdToXY(expansionId, baseSetup), x = _a.x, y = _a.y;
    var pos = utilGrid.objectCenterOnScreenGlobal({
        id: expansionId,
        x: x,
        xExtent: baseSetup.expansionsSizeX,
        y: y,
        yExtent: baseSetup.expansionsSizeY,
    });
    return viewport.toGlobal(new Point(pos.x, pos.y));
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectUnlockableExpansionIds.ts
// module id = 552
// module chunks = 3